import { Outlet } from 'react-router-dom';
import CompanyNav from '@composites/CompanyNav';
import PortfolioOverviewFooter from '@composites/PortfolioOverviewFooter';

const CompanyLayout = () => {
  return (
    <>
      <CompanyNav />
      <Outlet />
      <PortfolioOverviewFooter />
    </>
  );
};

export default CompanyLayout;
